function obtainClassName(pfe, selected) {
  let className;
  if (pfe) {
    className = 'rate-line-pfe';
  } else {
    className = 'rate-line';
  }
  if (selected) {
    className += ' active';
  }
  return className;
}

export default function ({ onClick, name, selected, pfe, id }) {
  return (
    <div className={obtainClassName(pfe, selected)} onClick={onClick}>
      {name}
    </div>
  );
}
